import React, { FC, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { GridSkeleton } from 'components/Grid';
import SafePerfectScrollbar from 'components/SafePerfectScrollbar';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import useWorkbook from 'components/ScalarSpreadsheet/utilities/useWorkbook';
import useTrendsDetailData from '../../hooks/useTrendsDetailData';
import { ITrendsDetailTableProps } from '../../types';

const TrendsDetailTable: FC<ITrendsDetailTableProps> = ({ data, isLoading, format, formatDispatch }) => {
  const { spreadsheet: trendsDetailSheet } = useTrendsDetailData({ data, format });

  const [spreadsheets, setSpreadsheets] = useState([trendsDetailSheet]);

  useEffect(() => {
    if (trendsDetailSheet?.yLength > 0) {
      setSpreadsheets([trendsDetailSheet]);
    }
  }, [trendsDetailSheet]);

  const { onChange, workbook } = useWorkbook(spreadsheets);

  const trendsDetailSheetProps = {
    ...trendsDetailSheet,
    sheet: trendsDetailSheet,
    workbook,
    onChange,
    page: 'Valuation Trends',
    format,
    formatDispatch,
  };

  if (isLoading || !trendsDetailSheet?.data) {
    return <GridSkeleton />;
  }

  return (
    <SafePerfectScrollbar className="always-visible">
      <Grid container>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <ScalarSpreadsheet {...trendsDetailSheetProps} />
      </Grid>
    </SafePerfectScrollbar>
  );
};

export default TrendsDetailTable;
